
<div class="rmg" *ngIf="lval==1" > 

  <div class="text-center t"> 
    <button  class="btn btn-border btn-outline-warning text-light" (click)="lval=2" ><h5> Search Book </h5></button> 

</div>

</div>
<div *ngIf="lval==2" class="rmg "> 
  <div class="row container-fluid ">
  <div class="col-md-1 rg" > 
  <button  class="btn btn-border btn-outline-warning text-light" (click)="[lval=1,getbook()]"  ><h6>  Back</h6></button> 

</div>
<div  class="col-md-9 offset-2 row rg">
    <div class="form-group col-md-4">
        <select class="form-control" id="branch"  [(ngModel)]="selectedbranch">
       
          <option *ngFor="let bran of branch" [value]="bran">{{bran}}</option>
          <option  value="" [selected]="true">CHOOSE BRANCH</option>
        </select>
    </div>
    

    <div class="form-group col-md-3 offset-1">
        <select type="text" class="form-control"  [(ngModel)]="selectedSemester"  >

          <option  value="">CHOOSE SEMESTER</option>
          <option *ngFor="let sem of semester" [value]="sem">{{sem}}</option>
          
        </select>
       
    </div>
   <div class="col-md-2 offset-2"> <button type="button" class="btn btn-success text-center" (click)="[selectedBook()] ">SEARCH</button></div>



</div></div>
<div class="container-fluid  row">
  <div class="card  mb-3 crd offset-1" style="max-width: 15rem;" *ngFor="let book of bookListPresent">
    <div class="card-header text-dark"><h3><strong>{{book.bookName}}</strong></h3></div>
    <div class="card-body crd1">
      
      <p class="card-text">Year Of Publised : {{book.bookYear}}</p>
      <p class="card-text">Branch: {{book.branch}}</p>
      <p class="card-text">Semester : {{book.semester}}</p>
      <p class="card-text">Price : {{book.bookPrice}}</p>
    
      <p class="card-text">Seller : {{book.customer.customerName}}</p>
      <p class="card-text">Contact No : {{book.customer.contactNumber}}</p>
    
    </div>


  </div>
  <h5 class="error-message" *ngIf="err!=null">{{err}}</h5> 








</div>
</div>